import axios, { AxiosResponse } from "axios";
import { Order } from "../components/Client/MyOrders/MyOrders";

const BASE_URL = "https://sodastreamapi.azurewebsites.net/paystack";

class OrderService {

  async getAllOrders(): Promise<{ data: Order[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<Order[]> = await axios.get(`${BASE_URL}/orders`);
      if (response.status >= 200 && response.status < 300) {
        const orders: Order[] = response.data;

        return { data: orders, error: null };
      } else {
        const error = "Error fetching orders";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching orders:", error);
      return { data: null, error };
    }
  }

  async getOrderById(orderId: number): Promise<{ data: Order | null; error: string | null }> {
    try {
      const response: AxiosResponse<Order> = await axios.get(`${BASE_URL}/id/${orderId}`);
      if (response.status >= 200 && response.status < 300) {
        const order: Order = response.data;

        return { data: order, error: null };
      } else {
        const error = "Error fetching order by ID";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching order by ID:", error);
      return { data: null, error };
    }
  }


  async getOrderByUserId(userId: number): Promise<{ data: Order[] | null; error: string | null }> {
    try {
      const response: AxiosResponse<Order[]> = await axios.get(`${BASE_URL}/orderByUserId/${userId}`);
      if (response.status >= 200 && response.status < 300) {
        const orders: Order[] = response.data;

        return { data: orders, error: null };
      } else {
        const error = "Error fetching orders by user ID";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching orders by user ID:", error);
      return { data: null, error };
    }
  }

  // Method to create a new order
  async createOrder(orderData: any): Promise<{ data: Order | null; error: string | null }> {
    try {
      const response: AxiosResponse<Order> = await axios.post(BASE_URL, orderData);
      if (response.status >= 200 && response.status < 300) {
        const createdOrder: Order = response.data;

        return { data: createdOrder, error: null };
      } else {
        const error = `Error creating order - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error creating order:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }

  // Method to update the status of an order
  async updateOrderStatus(orderId: number, status: string): Promise<{ data: Order | null; error: string | null }> {
    try {
      const response: AxiosResponse<Order> = await axios.put(`${BASE_URL}orders/${orderId}/`, { status });
      if (response.status >= 200 && response.status < 300) {
        const updatedOrder: Order = response.data;
  
        return { data: updatedOrder, error: null };
      } else {
        const error = `Error updating order status - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error updating order status:", error.message);
      return { data: null, error: error.message };
    }
  }

  // Method to delete an order by ID
  async deleteOrder(orderId: number): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<any> = await axios.delete(`${BASE_URL}/${orderId}`);
      if (response.status >= 200 && response.status < 300) {

        return { data: response.data, error: null };
      } else {
        const error = `Error deleting order - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error deleting order:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }
}


const orderServiceInstance = new OrderService();

export default orderServiceInstance;
